import { cookieService } from "@/lib/cookie/cookieService";
import { create } from "zustand";
import { setAnalyticsUser } from "@/lib/analytics";

const getCookieDomain = () => {
  if (typeof window === "undefined") return undefined;

  const hostname = window.location.hostname;

  if (hostname.endsWith(".dev.togetherwork.vn")) {
    return ".dev.togetherwork.vn";
  }

  return undefined;
};

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  expired: number | null;
  setToken: (state: { token: string; expired: number }) => void;
  setRefreshToken: (state: { refreshToken: string; expired: number }) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  token: null,
  refreshToken: null,
  expired: null,
  user: null,
  setToken: (state) => {
    set({ token: state.token, expired: state.expired });
    cookieService.set("token", state.token, {
      encrypt: true,
      expires: state.expired,
      domain: getCookieDomain(),
    });
  },
  setRefreshToken: (state) => {
    set({ refreshToken: state.refreshToken });
    cookieService.set("refreshToken", state.refreshToken, {
      encrypt: true,
      expires: state.expired,
      domain: getCookieDomain(),
    });
  },
  logout: () => {
    cookieService.remove("token", { domain: getCookieDomain() });
    cookieService.remove("refreshToken", { domain: getCookieDomain() });
    cookieService.remove("businessId", { domain: getCookieDomain() });
    cookieService.remove("expired", { domain: getCookieDomain() });
    setAnalyticsUser(null);
    set({
      token: null,
      refreshToken: null,
      expired: null,
    });
  },
}));
